"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const react_router_redux_1 = require("react-router-redux");
const constants_1 = require("../constants");
const AuthenticationActions_1 = require("./AuthenticationActions");
const api_1 = require("../api");
const AuthenticationActions_2 = require("./AuthenticationActions");
const localStorage_1 = require("../localStorage");
const store_1 = require("../store");
const common_1 = require("../../common");
function authentication(state = constants_1.INITIAL_STATE.authentication, action) {
    switch (action.type) {
        case constants_1.ACTIONS.Authentication.LOGIN:
            api_1.doPost(api_1.API.v1.LOGIN, {
                email: action.payload.email,
                password: action.payload.password,
                remember: action.payload.remember
            }, false).then(response => {
                store_1.default.dispatch(AuthenticationActions_1.loginSuccess({
                    user: response.data.user,
                    accessToken: response.data.access_token,
                    socials: response.data.socials,
                    organization: response.data.user.organization
                }));
            }).catch(error => {
                api_1.dispatchError(error, () => {
                    store_1.default.dispatch(AuthenticationActions_1.loginFailed(error.response.data));
                });
            });
            return state;
        case constants_1.ACTIONS.Authentication.REGISTER_ORG:
            api_1.doPost(api_1.API.v2.ORGANIZATION.SIGN_UP(), {
                name: action.payload.name,
                email: action.payload.email,
                password: action.payload.password,
                organizationName: action.payload.organizationName
            }, false).then(response => {
                store_1.default.dispatch(AuthenticationActions_2.registerSuccess({
                    user: response.data.user,
                    accessToken: response.data.access_token,
                    organization: response.data.user && response.data.user.organization
                }));
            }).catch(error => {
                api_1.dispatchError(error, () => {
                    store_1.default.dispatch(AuthenticationActions_2.registerFailed(error.response.data));
                });
            });
            return state;
        case constants_1.ACTIONS.Authentication.UPDATE_ORG:
            api_1.doGet(api_1.API.v2.ORGANIZATION.GET(state.organization.routePrefix), {}, false).then(response => {
                store_1.default.dispatch(AuthenticationActions_1.updateOrganizationSuccess(response.data.response));
            }).catch(error => {
                api_1.dispatchError(error, () => {
                    store_1.default.dispatch(AuthenticationActions_2.registerFailed(error.response.data));
                });
            });
            return state;
        case constants_1.ACTIONS.Authentication.UPDATE_ORG_BY_ACCESSTOKEN:
            api_1.doGet(api_1.API.v2.ORGANIZATION.GET_BY_ACCESS_TOKEN(), {}).then(response => {
                store_1.default.dispatch(AuthenticationActions_1.updateOrganizationSuccess(response.data.response));
            }).catch(error => {
                api_1.dispatchError(error, () => {
                    store_1.default.dispatch(AuthenticationActions_2.registerFailed(error.response.data));
                });
            });
            return state;
        case constants_1.ACTIONS.Authentication.UPDATE_ORG_SUCCESS:
            const authenticationStoreAfterOrgUpdate = {
                organization: action.payload,
                accessToken: state.accessToken,
                user: state.user,
                socials: state.socials
            };
            localStorage_1.saveState(authenticationStoreAfterOrgUpdate);
            common_1.updateAppearance(authenticationStoreAfterOrgUpdate.organization.settings.appearance);
            return Object.assign({}, state, authenticationStoreAfterOrgUpdate);
        case constants_1.ACTIONS.Authentication.REGISTER:
            api_1.doPost(api_1.API.v1.REGISTER, {
                name: action.payload.name,
                email: action.payload.email,
                password: action.payload.password,
                routePrefix: action.payload.routePrefix
            }, false).then(response => {
                store_1.default.dispatch(AuthenticationActions_2.registerSuccess({
                    user: response.data.user,
                    accessToken: response.data.access_token,
                    organization: response.data.user && response.data.user.organization
                }));
            }).catch(error => {
                api_1.dispatchError(error, () => {
                    store_1.default.dispatch(AuthenticationActions_2.registerFailed(error.response.data));
                });
            });
            return state;
        case constants_1.ACTIONS.Authentication.LOGIN_SUCCESS:
            const authenticationStore = {
                accessToken: action.payload.accessToken,
                user: action.payload.user,
                socials: action.payload.socials,
                organization: action.payload.organization
            };
            localStorage_1.saveState(authenticationStore);
            return Object.assign({}, state, authenticationStore);
        case constants_1.ACTIONS.Authentication.LOGOUT:
            api_1.doGet(api_1.API.v1.LOGOUT_REDIRECT_URL).then(response => {
                store_1.default.dispatch(AuthenticationActions_1.deleteState());
                lodash_1.delay(() => {
                    window.location.replace(response.data.redirectUrl);
                }, 500);
            }).catch(error => {
                store_1.default.dispatch(react_router_redux_1.push('/'));
                store_1.default.dispatch(AuthenticationActions_1.deleteState());
            });
            return state;
        case constants_1.ACTIONS.Authentication.DELETE_STATE:
            return {};
        case constants_1.ACTIONS.Socials.SET_ACTIVE_SOCIAL:
            {
                const activatedSocial = action.payload.social;
                let socials = [];
                state.socials.forEach(social => {
                    if (activatedSocial !== social) {
                        socials.push(social);
                    }
                });
                if (socials.length == 0) {
                    socials = [];
                }
                const authenticationStore = {
                    accessToken: state.accessToken,
                    user: state.user,
                    socials
                };
                localStorage_1.saveState(authenticationStore);
                return Object.assign({}, state, authenticationStore);
            }
        case constants_1.ACTIONS.Authentication.TIME_ZONE:
            const user = state.user;
            user.timezone = action.payload;
            return Object.assign({}, state, { user });
        default:
            return state;
    }
}
exports.default = authentication;


//////////////////
// WEBPACK FOOTER
// ./client/src/authentication/AuthenticationReducer.ts
// module id = 607
// module chunks = 0 1 2